import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { CliniqueState, Retailer, StepView } from '../type';

export const Footer = (props: { step: StepView; inResult?: boolean }) => {
	const { t } = useTranslation();
	const { retailer } = useSelector((state: CliniqueState) => state.session);

	const handlePrivacyPolicy = () => {
		if (retailer === Retailer.sephora) {
			window.open('https://www.sephora.fr/mentions-legales.html', '_blank');
		} else {
			window.open(t('privacy-policy-link'), '_blank');
		}
	};

	return (
		<FooterContainer inResult={props.inResult} step={props.step}>
			<PrivacyPolicyText whileTap={{ scale: 1.1 }} onClick={() => handlePrivacyPolicy()}>
				{t('privacy-policy', 'Privacy policy')}
			</PrivacyPolicyText>
		</FooterContainer>
	);
};

const isDark = (step: StepView) => {
	switch (step) {
		case StepView.quests:
		case StepView.results:
		case StepView.onBoard:
		case StepView.ready:
		case StepView.micrositeIntro:
		case StepView.shadematchPictureAnalyse:
			return true;
		default:
			return false;
	}
};

const handleFooterPosition = (step: StepView) => {
	switch (step) {
		case StepView.quests:
			return 'relative';
		case StepView.tuto:
			return 'fixed';
		case StepView.shadematchPictureAnalyse:
			return 'fixed';
		default:
			return 'absolute';
	}
};

export const FooterContainer = styled.div<{ step: StepView; inResult?: boolean }>`
	display: ${(props) => (props.step === StepView.onBoard ? 'none' : 'flex')};
	align-items: center;
	justify-content: space-between;
	position: ${(props) => handleFooterPosition(props.step)};
	bottom: 0px;
	width: 100%;
	box-sizing: border-box;
	padding: ${(props) => (props.step === StepView.results ? '24px 40px' : '24px')};
	z-index: 1;
	filter: ${(props) => (isDark(props.step) ? 'brightness(0)' : '')};

	@media (max-width: 768px) {
		padding: ${(props) => !props.inResult && '16px'};
		padding: ${(props) => (props.step === StepView.results ? '24px 16px' : '16px')};
		left: 0px;
	}
`;

const PrivacyPolicyText = styled(motion.p)`
	color: white;
	margin: 0px;
	text-decoration: underline;
	font: normal normal 400 18px/100% 'Clinique Helvetica Neue';

	@media (max-width: 768px) {
		font-size: 14px;
	}
`;
